import {Node} from "@xyflow/react";
import {VERTICAL_NODE_GAP} from "./FamilyTreeLayoutConstants";
import {isOtherMembersSection} from "./FamilyTreeNodeUtils";

export function buildLevelMap(nodes: Node[]) {
    const levelMap = new Map<number, Node[]>();
    nodes.forEach(node => {
        if (isOtherMembersSection(node)) return;
        const y = node.position.y ?? 0;
        const normalized = y / VERTICAL_NODE_GAP;
        const level = Math.floor(normalized + 1e-6);
        if (!levelMap.has(level)) levelMap.set(level, []);
        levelMap.get(level)!.push(node);
    });
    return levelMap;
}
